// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__U7J-6","gene":"Footer_gene__lfUm+","sample":"Footer_sample__jTJpv"};